import { findIndex } from 'lodash';
import { put } from 'redux-saga/effects';
import {
  ModelEntityWithResult,
  ModelEntityWithScores,
  ModelResult,
  ModelResultWithScores,
} from '@upright/common/model/output/scores/model-entity-data/types';
import { requestFailed } from '../../../untidy/redux/actions/actions';

export function assertNever(x: never): never {
  // Comment out the following line if we don't want to error out if we somehow hit this
  throw new Error(`Unexpected object: ${x as string}`);
}

export function replaceOrAddToArray<T>(arr: T[], predicate: (d: T) => boolean, newValue: T): T[] {
  const index = findIndex(arr, predicate);
  if (index === -1) {
    return arr.concat(newValue);
  }
  return Object.assign([], arr, { [index]: newValue });
}

export function* handleSagaException(e: unknown, requestId: string, friendlyMessage?: string) {
  console.error('Saga exception', e);
  const error = e instanceof Error ? e : new Error(friendlyMessage ?? 'Something went wrong!', { cause: e });
  yield put(requestFailed(requestId, error.message));
}

export function requireOnlyOneModelResult<T extends ModelEntityWithResult | ModelEntityWithScores>(
  entity: T,
): T extends ModelEntityWithScores ? ModelResultWithScores : ModelResult {
  const modelResults = entity.modelResults;
  if (modelResults.length > 1) {
    throw Error(`Not allowed to have multiple model results per weight set item. Entity: ${entity.type}, ${entity.id}`);
  }

  // OA: This casting is a bit ugly, but the end result of the function is what we want. Feel free to refactor if you
  // can think of a better way :)
  const ret = modelResults[0] as T extends ModelEntityWithScores ? ModelResultWithScores : ModelResult;
  return ret;
}
